import type { RefObject } from "react";
import { Icon } from "./Icon";

interface MobileHeaderProps {
  menuButtonRef: RefObject<HTMLButtonElement | null>;
  menuOpen: boolean;
  onMenuOpen: () => void;
}

export function MobileHeader({ menuButtonRef, menuOpen, onMenuOpen }: MobileHeaderProps) {
  return (
    <header className={`mobile-header${menuOpen ? " is-menu-open" : ""}`}>
      <div className="brand-lockup" aria-label="JH Second Brain">
        <strong>JH</strong>
        <span aria-hidden="true">/</span>
        <span>SECOND BRAIN</span>
      </div>
      <button
        aria-controls="graph-sidebar"
        aria-expanded={menuOpen}
        aria-label="탐색 메뉴 열기"
        className="mobile-menu"
        onClick={onMenuOpen}
        ref={menuButtonRef}
        type="button"
      >
        <Icon name="menu" size={23} />
      </button>
    </header>
  );
}
